import { green, red } from '@mui/material/colors';
import { differenceInMinutes } from 'date-fns';
import { INVENTORY_STATUS } from 'utils/constants';

export const getInventoryStatusColor = (status) =>
    INVENTORY_STATUS[status] === INVENTORY_STATUS.GOOD_TO_GO
        ? { color: green[600], backgroundColor: green[200] }
        : { color: red[600], backgroundColor: red[200] };

export const formatSummaryDuration = (minutes) => {
    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const remainingMinutes = minutes % 60;

    const dayText = days > 0 ? `${days}d ` : '';
    const hourText = hours > 0 ? `${hours}h ` : '';
    const minuteText = `${remainingMinutes}m`;

    return `${dayText}${hourText}${minuteText}`.trim();
};

export const calculateDurationInYard = (checkInDate, selectedDate) => {
    const currentDate = selectedDate || new Date();
    currentDate.setSeconds(59);

    const checkIn = new Date(checkInDate);

    if (isNaN(checkIn.getTime())) {
        return '';
    }

    return differenceInMinutes(currentDate, checkIn);
};

export const calculateSortDurationValue = (row) => row.durationInYardMinutes;
